import{useRef as r,useEffect as t}from"react";var n=function(n){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],c=r(!0);t((function(){c.current?c.current=!1:n()}),o)};export{n as useUpdateEffect};
